// extracted by mini-css-extract-plugin
export default {"actionButton":"WisePdpActionButton_actionButton__Kq-AE"};